import actionTypes from './actionTypes'

const topbarActions = {
	signIn() {
		return {
			type: actionTypes.TOPBAR_SIGN_IN,
		}
	},
	signUp() {
		return {
			type: actionTypes.TOPBAR_SIGN_UP,
		}
	},
	redirectTo(redirectUrl) {
		return {
			type: actionTypes.TOPBAR_REDIRECT,
			redirectUrl,
		}
	},
}

export default topbarActions
